import script from "./HeaderNotificationsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderNotificationsModal.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderNotificationsModal.vue?vue&type=style&index=0&id=50e3a888&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50e3a888"]])

export default __exports__